export default {
  surveys: [],
  surveysCount: 0
}
